import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { ActivationStatus } from 'src/app/shared/enums/general.enum'
import { OfferModelData } from '../../models/offer.model'
import { Subscription } from 'rxjs'
import { environment } from 'src/environments/environment'
import { MatDialog } from '@angular/material/dialog'
import { UploadImageComponent } from 'src/app/shared/components/upload-image/upload-image.component'
import { ImageUpload } from 'src/app/shared/models/general.models'
import { OffersService } from '../../services/offers.service'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { ToastrService } from 'ngx-toastr'
import { SharedService } from 'src/app/shared/services/shared.service'

@Component({
	selector: 'app-add-promo-code-basic-info',
	templateUrl: './add-promo-code-basic-info.component.html',
	styleUrls: ['./add-promo-code-basic-info.component.scss'],
})
export class AddPromoCodeBasicInfoComponent implements OnInit {
	@Input() offerData!: OfferModelData
	@Input() isAddMode: boolean = false
	@Output() dataChanged: EventEmitter<any> = new EventEmitter()
	@Input() editMode: boolean = false
	subscription = new Subscription()
	offerForm: FormGroup = new FormGroup({})
	attachmentUrl = environment.attachmentPath
	isActiveEnum = ActivationStatus
	oldValues = null
	isChanged = false
	imgConfig: ImageUpload = {
		imageCropDimensions: 2.1,
		imageWidth: 800,
		imageHeight: 500,
	}
	isActive: boolean = false
	isAppointmentsCount: boolean = false
	today = new Date()
	constructor(
		public translate: TranslateService,
		private dialog: MatDialog,
		private offerService: OffersService,
		private toaster: ToastrService,
		private sharedServ: SharedService
	) {}

	ngOnInit(): void {
		this.initForm()
	}

	initForm() {
		this.offerForm = new FormGroup({
			// id: new FormControl(this.offerData?.id),
			name: new FormGroup({
				ar: new FormControl(this.offerData?.name?.ar, [Validators.required]),
				en: new FormControl(this.offerData?.name?.en, [Validators.required]),
			}),

			image: new FormGroup({
				ar: new FormControl(this.offerData?.image?.ar, [Validators.required]),
				en: new FormControl(this.offerData?.image?.en, [Validators.required]),
			}),
			code: new FormControl(this.offerData?.code, [Validators.required]),
			startDate: new FormControl(
				{
					value: this.offerData?.startDate,
					disabled: new Date(this.offerData?.startDate) < this.today,
				},
				[Validators.required]
			),
			endDate: new FormControl(
				{
					value: this.offerData?.endDate,
					disabled: new Date(this.offerData?.endDate) < this.today,
				},
				[Validators.required]
			),
			maxNoOfClientUsage: new FormControl(
				this.offerData?.maxNoOfClientUsage
					? this.offerData?.maxNoOfClientUsage
					: 1,
				[Validators.required, Validators.min(1)]
			),
			maxNoOfBookings: new FormControl(this.offerData?.maxNoOfBookings, [
				Validators.required,
				Validators.min(this.offerData?.appointmentsCount),
			]),
			isActive: new FormControl(this.offerData?.isActive || true),
		})
		this.oldValues = this.offerForm.getRawValue()
		this.subscription.add(
			this.offerForm.valueChanges.subscribe((res) => {
				this.isChanged = JSON.stringify(this.oldValues) != JSON.stringify(res)
				this.dataChanged.emit({ value: res, isInvalid: this.offerForm.invalid })
			})
		)
	}
	skipLetterE(event: any) {
		if (event.key.toLowerCase() === 'e') {
			event.preventDefault()
		}
	}

	checkLength(controller: string, input: any, maxLength: number) {
		this.getController(controller).setValue(
			input.target.value.slice(0, maxLength)
		)
	}

	changeEditMode() {
		this.initForm()
		this.editMode = !this.editMode
		if (this.offerData?.appointmentsCount > 0) {
			this.isAppointmentsCount = true
			this.getController('name').get('en')?.disable()
			this.getController('name').get('ar')?.disable()
			this.getController('image').get('ar')?.disable()
			this.getController('image').get('en')?.disable()
			this.getController('code').disable()
		}
		// this.editMode ? this.offerForm.enable() : this.offerForm.disable()
	}
	updateStatus(event: any) {
		let requestBody = {
			id: this.offerData.id,
			isActive: !this.offerData.isActive,
		}
		const active = !this.offerData.isActive
		event.source.checked = this.offerData.isActive


		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '416',
				height: '360',

				data: {
					image: `assets/images/${!active ? 'block.svg' : 'correct.svg'}`,
					notflex: true,

					message: active
						? 'CONFIRMATION_MESSAGE.ACTIVATION_CONFIRMATION'
						: 'CONFIRMATION_MESSAGE.DEACTIVATION_CONFIRMATION',
					cancelBtn: 'ACTIONS.CANCEL',
					confirmBtn: active ? 'ACTIONS.ACTIVATE' : 'ACTIONS.DEACTIVATE',
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						this.subscription.add(
							this.offerService
								.updateOfferStatus(requestBody)
								.subscribe((res) => {
									if(res){
									this.offerData.isActive = active

										this.offerData.isActive = !event.source.checked
									}
								})
						)
					}
				},
			})
	}
	uploadImage(imageName: string) {
		this.dialog
			.open(UploadImageComponent, {
				width: '752px',

				panelClass: ['overflow-y-auto'],
				data: this.imgConfig,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						const body = new FormData()
						body.append('image', res.selectedFile)
						this.subscription.add(
							this.offerService.UploadOfferImage(body).subscribe((res: any) => {
								this.isChanged = true
								imageName == 'ar'
									? this.getController('image')
											.get('ar')
											?.setValue(res?.result?.url)
									: this.getController('image')
											.get('en')
											?.setValue(res?.result?.url)
							})
						)
					}
				},
			})
	}

	updateData() {
		const Body = {
			id: this.offerData.id,
			...this.offerForm.getRawValue(),
		}
		Body.startDate = this.sharedServ.handleDate(Body.startDate)
		Body.endDate = this.sharedServ.handleDate(Body.endDate)
		this.subscription.add(
			this.offerService.updateOfferBasicInfo(Body).subscribe((res) => {
				this.offerData = { ...this.offerData, ...Body }
				this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
				this.editMode = false
				this.dataChanged.emit()
			})
		)
	}
	getController(controlName: string) {
		return this.offerForm.controls[controlName]
	}
	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
